import request from '../../src/state/modules/axios'

export function getCategory(){
    return request({
        url: '/api/category',
        method: 'get',
    })
}

export function getCategoryById(data){
    return request({
        url: `/api/category/${data.id}`,
        method: 'get',
    })
}

export function addCategory(data){
    return request({
        url: '/api/category',
        method: 'post',
        data,
    })
}

export function editCategory(data){
    return request({
        url: `/api/category/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteCategory(data){
    return request({
        url: `/api/category/${data.id}`,
        method: 'delete'
    })
}
